/**
 * Utility function to process column width values for TableAdv component
 * Handles different width formats including Tailwind classes and direct CSS values
 * @param {string|undefined} width - The width value to process
 * @returns {Object} Object containing classes string and styles object
 */
const processColumnWidth = (width) => {
  if (!width) return { classes: "", styles: {} };
  const classes = [];
  const styles = {};

  const addToken = (token) => {
    if (!token || typeof token !== "string") return;
    if (token === "auto") {
      styles.width = "auto";
      return;
    }
    classes.push(token);
    const m = token.match(/^(w|min-w|max-w)-\[(.+)\]$/);
    if (m) {
      const [, type, value] = m;
      if (type === "w") styles.width = value;
      if (type === "min-w") styles.minWidth = value;
      if (type === "max-w") styles.maxWidth = value;
    }
  };

  if (typeof width === "string") {
    const tokens = width.trim().split(/\s+/);
    tokens.forEach(addToken);
    if (tokens.length === 1) {
      const single = tokens[0];
      if (/^\d+(\.\d+)?(px|rem|em|%|vw|vh)$/.test(single)) {
        styles.width = single;
      } else if (single === "auto") {
        styles.width = "auto";
      }
    }
    return { classes: classes.join(" "), styles };
  }

  if (typeof width === "object") {
    const w = width.width ?? width.w;
    const min = width.minWidth ?? width.min ?? width.minW;
    const max = width.maxWidth ?? width.max ?? width.maxW;

    if (typeof w === "string") {
      if (w === "auto") {
        styles.width = "auto";
      } else if (/^\d+(\.\d+)?(px|rem|em|%|vw|vh)$/.test(w)) {
        styles.width = w;
      } else {
        addToken(w);
      }
    }
    if (typeof min === "string") {
      if (/^\d+(\.\d+)?(px|rem|em|%|vw|vh)$/.test(min)) styles.minWidth = min;
      else addToken(min);
    }
    if (typeof max === "string") {
      if (/^\d+(\.\d+)?(px|rem|em|%|vw|vh)$/.test(max)) styles.maxWidth = max;
      else addToken(max);
    }
    return { classes: classes.join(" "), styles };
  }

  if (typeof width === "number") {
    styles.width = `${width}px`;
    return { classes: "", styles };
  }

  return { classes: "", styles };
};

export default processColumnWidth;
